import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative px-5 sm:px-10 lg:px-16 pt-16 pb-10 border-t border-[#F5A524]/15 overflow-hidden">
    <p aria-hidden="true" className="font-display font-black uppercase text-stroke leading-[0.8] text-[22vw] tracking-tight select-none">Emporio</p>
    <div className="mt-8 flex flex-col sm:flex-row justify-between gap-4 font-mono text-[11px] tracking-[0.25em] text-zinc-400">
      <span className="flex items-center gap-3"><LogoMark className="w-5 h-5" /> © {new Date().getFullYear()} LAWRENCE'S EMPORIO</span>
      <span>ALL WORKS © THE ARTIST</span>
      <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[#F5A524] transition-colors">[ SYS_OVERRIDE ]</Link>
    </div>
  </footer>
);
